
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.page-naitei2021-file')) {
    setSlide()
  }
})

function setSlide() {
  const slide = new Swiper('.js-slider', {
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 600,
    loop: true,
    slidesPerView: 1.4,
    centeredSlides: true,
    spaceBetween: 10,
    // autoplay: 5000,
    loopAdditionalSlides: 12,
    breakpoints: {
      992: {
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: 0,
      },
    },
  })
}



